import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here

import StageMediaView from "../../views/stage/StageMediaView.jsx"
import StageElementListView from "../../views/stage/StageElementListView.jsx"

class StageDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      stageData: {},
      imageHolderHeight: 0,
      moviePlayerHolderHeight: 0,
      stageElementListViewHeight: 0,
    };
    autoBind(this);
  }

  refresh() {
    let stage_id = this.state.stageData['id'];
    if (stage_id > 0) {
      // stage no longer exist
      if (this.props.parent.getStageDataById(stage_id) == null) {
        // set to null, render function will output blank
        this.setState({
          stageData:{},
        });
        this.state.stageData = {};
      }
      else{
        this.updateStageDetail(this.state.stageData['id']);
      }
    }
  }

  updateStageDetail(stage_id) {
    let requestObj = {
      stage_id: stage_id,
    };
    this.props.root.refs.API.request("get_stage_by_stage_id", requestObj, this.getStageDetailOK, this.getStageDetailFailed);
  }

  getStageDetailOK(res) {
    console.log("getStageDetailOK");
    this.setState({
      stageData: res.body['result'],
    });
    this.state.stageData = res.body['result'];

    if (this.refs.stageMediaView) {
      this.refs.stageMediaView.setState({
        playbackDuration: this.state.stageData.duration,
      });
    }

    if(this.refs.stageMediaView){
      this.refs.stageMediaView.refreshPlaybackTime();
    }
  }

  getStageDetailFailed(err) {
    console.log("get stage detail failed " + err);
  }

  onPlaybackTimeUpdate() {
    this.refs.stageElementListView.forceUpdate();
  }

  render() {
    return (
      <div style={{overflow:'hidden'}}>
        <If condition={this.state.stageData['id'] >= 0}>
          <Then>
            <StageMediaView parent={this} root={this.props.root} ref="stageMediaView"
              maxHeight={this.props.maxHeight}
              showAIGeneration={this.props.showAIGeneration}
              aiGenerateEnabled={this.props.aiGenerateEnabled}
              aiGenerateQuotaTotal={this.props.aiGenerateQuotaTotal}
              localeData={this.props.localeData}
              onUploadSuccess={this.props.onUploadSuccess}
            />
            <StageElementListView parent={this} root={this.props.root} ref="stageElementListView"
              stageData={this.state.stageData}
            />
          </Then>
          <Else>
            <If condition={this.props.parent.state.stageList.length == 0}>
              <Then>
                <div style={{display:'flex', alignItems:'center', justifyContent:'center', height:this.props.maxHeight}}>
                  There is no stage content to show.
                </div>
              </Then>
            </If>
          </Else>
        </If>
      </div>
    )
  }
}

export default StageDetailView;
